import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, t as toPathString, c as serializeDataIfNeeded, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ReturnsApi - axios parameter creator
 * @export
 */
const ReturnsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Το τροφοδοτεί ο διάλογος μαζικής αλλαγής κατάστασης και των δύο διαχειριστικών: η `returns/items` είναι όλα-ή-τίποτα, οπότε επιλέξιμος είναι μόνο στόχος που δέχεται <b>όλη</b> την επιλογή. `POST` για ανάγνωση με τα ids στο σώμα, όπως το `returns/lookup` της V2. Το σκεπτικό είναι στο `task-analysis/BW-7549`.
         * @summary Σε ποιες καταστάσεις μπορεί να πάει <b>όλη</b> η επιλογή τεμαχίων, και τι εμποδίζει τις υπόλοιπες. (Auth roles: Orders)
         * @param {ReturnBulkStatusOptionsArgs} [ReturnBulkStatusOptionsArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkStatusOptions: async (ReturnBulkStatusOptionsArgs, options = {}) => {
            const localVarPath = `/v1/Returns/bulk-status-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReturnBulkStatusOptionsArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * (Δεσμευτικό, Δ-06) Οι selectors απολυμαίνονται με allow-list σε `Filter`, `Sort`<b>και</b>`Group`, και το κριτήριο είναι η <b>απόρριψη</b>: άγνωστος selector οδηγεί σε σφάλμα αιτήματος και δεν προωθείται ποτέ αυτούσιος στο query.
         * @summary Η λίστα αιτημάτων, μία γραμμή ανά τεμάχιο. Ακολουθεί την υπάρχουσα σύμβαση των admin grids του εργαλείου: GET με `DataSourceLoadOptions` στο query string (απόφαση 2026-08-03). (Auth roles: Orders)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (loadOptions, options = {}) => {
            const localVarPath = `/v1/Returns/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (loadOptions !== undefined) {
                for (const [key, value] of Object.entries(loadOptions)) {
                    localVarQueryParameter[key] = value;
                }
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Το popup επεξεργασίας — το μόνο read surface που επιστρέφει τραπεζικά στοιχεία. (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/Returns/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Κατάσταση, επιθυμητή ενέργεια και παρατηρήσεις για <b>ένα</b> τεμάχιο. (Auth roles: Orders)
         * @param {ReturnItemUpdateArgs} [ReturnItemUpdateArgs]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        item: async (ReturnItemUpdateArgs, id, options = {}) => {
            const localVarPath = `/v1/Returns/Item`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReturnItemUpdateArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Το ίδιο για επιλεγμένο σύνολο τεμαχίων — απαραίτητο επειδή ένα αίτημα «σκάει» σε πολλά τεμάχια. (Auth roles: Orders)
         * @param {ReturnItemsUpdateArgs} [ReturnItemsUpdateArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        items: async (ReturnItemsUpdateArgs, options = {}) => {
            const localVarPath = `/v1/Returns/Items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReturnItemsUpdateArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Χωριστό, <b>authorised</b> endpoint και όχι το γενικό anonymous `binaryrepofiles/get`: οι φωτογραφίες επιστροφής είναι στοιχεία αιτήματος πελάτη (ενότητα 14). Ο τύπος περιεχομένου είναι ο <b>αναγνωρισμένος από magic bytes</b> που κρατά η γραμμή, όχι ο δηλωμένος από τον uploader.
         * @summary Το περιεχόμενο μιας φωτογραφίας πελάτη, για το popup του διαχειριστή. (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photo: async (id, options = {}) => {
            const localVarPath = `/v1/Returns/Photo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary (Α-29) Καταγράφει επιστροφή χρημάτων που ο διαχειριστής έχει <b>ήδη εκτελέσει εκτός πλατφόρμας</b>. Καταγράφει γεγονός: δεν καλεί ποτέ πάροχο πληρωμών ή τράπεζα (Δ-10). (Auth roles: Orders)
         * @param {RefundExecutionArgs} [RefundExecutionArgs]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundExecution: async (RefundExecutionArgs, id, options = {}) => {
            const localVarPath = `/v1/Returns/refund-execution`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RefundExecutionArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Επιτρέπεται μόνο όσο <b>κάθε</b> τεμάχιο είναι «Νέο αίτημα». (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/Returns/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary (Α-30) Καταγράφει αντικατάσταση που ο διαχειριστής έχει <b>ήδη στείλει</b>, ανά τεμάχιο (Δ-11). (Auth roles: Orders)
         * @param {ReplacementDispatchArgs} [ReplacementDispatchArgs]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replacementDispatch: async (ReplacementDispatchArgs, id, options = {}) => {
            const localVarPath = `/v1/Returns/replacement-dispatch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReplacementDispatchArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary (Α-30, Δ-11) Καταγράφει αποστολή <b>γραμμής του καλαθιού</b> αντικατάστασης — εκεί ζει ο στόχος όταν το αίτημα ήρθε από τον πελάτη (BW-7548). Η «Ολοκληρώθηκε» ανοίγει όταν έχουν καταγραφεί όλες οι γραμμές. (Auth roles: Orders)
         * @param {ReplacementLineDispatchArgs} [ReplacementLineDispatchArgs]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replacementLineDispatch: async (ReplacementLineDispatchArgs, id, options = {}) => {
            const localVarPath = `/v1/Returns/replacement-line-dispatch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReplacementLineDispatchArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Δικό του endpoint του module και όχι το `products/getsimplelookup` του καταλόγου, για δύο λόγους:             το lookup του καταλόγου είναι `[Authorize(Roles = \"Catalog\")]` ενώ αυτή η σελίδα είναι ρόλου             `Orders` — ένας διαχειριστής παραγγελιών έπαιρνε 403 και άδειο επιλογέα — και επιστρέφει             <b>ολόκληρο</b> τον κατάλογο χωρίς όρο ή σελιδοποίηση.  Η ίδια υπηρεσία με το storefront: ό,τι προσφέρεται εδώ το δέχεται και ο             BizWeb.NC.Returns.IReturnReplacementTargetResolver στην αποθήκευση, οπότε ο διαχειριστής δεν μπορεί να             διαλέξει στόχο με βέβαιη απόρριψη.
         * @summary (Α-31) Υποψήφια προϊόντα για στόχο αντικατάστασης, για τον επιλογέα του popup. (Auth roles: Orders)
         * @param {ReturnReplacementSearchArgs} [ReturnReplacementSearchArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replacementSearch: async (ReturnReplacementSearchArgs, options = {}) => {
            const localVarPath = `/v1/Returns/replacement-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReturnReplacementSearchArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary (Α-31) Ο στόχος αντικατάστασης ενός τεμαχίου, όπως τον επιλέγει ο διαχειριστής. Επικυρώνεται έναντι του καταλόγου με τον <b>ίδιο</b> κανόνα που εφαρμόζει η υποβολή του πελάτη. (Auth roles: Orders)
         * @param {ReplacementSelectionArgs} [ReplacementSelectionArgs]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replacementSelection: async (ReplacementSelectionArgs, id, options = {}) => {
            const localVarPath = `/v1/Returns/replacement-selection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReplacementSelectionArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ίδιος κανόνας — και ίδιος κώδικας — με τους υποψηφίους που βλέπει ο πελάτης στο lookup, ώστε ο επιλογέας του διαχειριστή να μην προσφέρει παραλλαγή που η αποθήκευση θα απέρριπτε ως `returns_replacement_target_out_of_stock`.
         * @summary Οι παραλλαγές ενός προϊόντος που μπορούν να σταλούν ως αντικατάσταση: ορατές, με απόθεμα και με ενεργή βασική τιμή. (Auth roles: Orders)
         * @param {number} [productId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replacementVariants: async (productId, options = {}) => {
            const localVarPath = `/v1/Returns/replacement-variants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ReturnsApi - functional programming interface
 * @export
 */
const ReturnsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReturnsApiAxiosParamCreator(configuration);
    return {
        /**
         * Το τροφοδοτεί ο διάλογος μαζικής αλλαγής κατάστασης και των δύο διαχειριστικών: η `returns/items` είναι όλα-ή-τίποτα, οπότε επιλέξιμος είναι μόνο στόχος που δέχεται <b>όλη</b> την επιλογή. `POST` για ανάγνωση με τα ids στο σώμα, όπως το `returns/lookup` της V2. Το σκεπτικό είναι στο `task-analysis/BW-7549`.
         * @summary Σε ποιες καταστάσεις μπορεί να πάει <b>όλη</b> η επιλογή τεμαχίων, και τι εμποδίζει τις υπόλοιπες. (Auth roles: Orders)
         * @param {ReturnBulkStatusOptionsArgs} [ReturnBulkStatusOptionsArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkStatusOptions(ReturnBulkStatusOptionsArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkStatusOptions(ReturnBulkStatusOptionsArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.bulkStatusOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * (Δεσμευτικό, Δ-06) Οι selectors απολυμαίνονται με allow-list σε `Filter`, `Sort`<b>και</b>`Group`, και το κριτήριο είναι η <b>απόρριψη</b>: άγνωστος selector οδηγεί σε σφάλμα αιτήματος και δεν προωθείται ποτέ αυτούσιος στο query.
         * @summary Η λίστα αιτημάτων, μία γραμμή ανά τεμάχιο. Ακολουθεί την υπάρχουσα σύμβαση των admin grids του εργαλείου: GET με `DataSourceLoadOptions` στο query string (απόφαση 2026-08-03). (Auth roles: Orders)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(loadOptions, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(loadOptions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Το popup επεξεργασίας — το μόνο read surface που επιστρέφει τραπεζικά στοιχεία. (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Κατάσταση, επιθυμητή ενέργεια και παρατηρήσεις για <b>ένα</b> τεμάχιο. (Auth roles: Orders)
         * @param {ReturnItemUpdateArgs} [ReturnItemUpdateArgs]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async item(ReturnItemUpdateArgs, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.item(ReturnItemUpdateArgs, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.item']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Το ίδιο για επιλεγμένο σύνολο τεμαχίων — απαραίτητο επειδή ένα αίτημα «σκάει» σε πολλά τεμάχια. (Auth roles: Orders)
         * @param {ReturnItemsUpdateArgs} [ReturnItemsUpdateArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async items(ReturnItemsUpdateArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.items(ReturnItemsUpdateArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.items']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Χωριστό, <b>authorised</b> endpoint και όχι το γενικό anonymous `binaryrepofiles/get`: οι φωτογραφίες επιστροφής είναι στοιχεία αιτήματος πελάτη (ενότητα 14). Ο τύπος περιεχομένου είναι ο <b>αναγνωρισμένος από magic bytes</b> που κρατά η γραμμή, όχι ο δηλωμένος από τον uploader.
         * @summary Το περιεχόμενο μιας φωτογραφίας πελάτη, για το popup του διαχειριστή. (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async photo(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.photo(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.photo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary (Α-29) Καταγράφει επιστροφή χρημάτων που ο διαχειριστής έχει <b>ήδη εκτελέσει εκτός πλατφόρμας</b>. Καταγράφει γεγονός: δεν καλεί ποτέ πάροχο πληρωμών ή τράπεζα (Δ-10). (Auth roles: Orders)
         * @param {RefundExecutionArgs} [RefundExecutionArgs]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refundExecution(RefundExecutionArgs, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refundExecution(RefundExecutionArgs, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.refundExecution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Επιτρέπεται μόνο όσο <b>κάθε</b> τεμάχιο είναι «Νέο αίτημα». (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary (Α-30) Καταγράφει αντικατάσταση που ο διαχειριστής έχει <b>ήδη στείλει</b>, ανά τεμάχιο (Δ-11). (Auth roles: Orders)
         * @param {ReplacementDispatchArgs} [ReplacementDispatchArgs]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replacementDispatch(ReplacementDispatchArgs, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replacementDispatch(ReplacementDispatchArgs, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.replacementDispatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary (Α-30, Δ-11) Καταγράφει αποστολή <b>γραμμής του καλαθιού</b> αντικατάστασης — εκεί ζει ο στόχος όταν το αίτημα ήρθε από τον πελάτη (BW-7548). Η «Ολοκληρώθηκε» ανοίγει όταν έχουν καταγραφεί όλες οι γραμμές. (Auth roles: Orders)
         * @param {ReplacementLineDispatchArgs} [ReplacementLineDispatchArgs]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replacementLineDispatch(ReplacementLineDispatchArgs, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replacementLineDispatch(ReplacementLineDispatchArgs, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.replacementLineDispatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  Δικό του endpoint του module και όχι το `products/getsimplelookup` του καταλόγου, για δύο λόγους:             το lookup του καταλόγου είναι `[Authorize(Roles = \"Catalog\")]` ενώ αυτή η σελίδα είναι ρόλου             `Orders` — ένας διαχειριστής παραγγελιών έπαιρνε 403 και άδειο επιλογέα — και επιστρέφει             <b>ολόκληρο</b> τον κατάλογο χωρίς όρο ή σελιδοποίηση.  Η ίδια υπηρεσία με το storefront: ό,τι προσφέρεται εδώ το δέχεται και ο             BizWeb.NC.Returns.IReturnReplacementTargetResolver στην αποθήκευση, οπότε ο διαχειριστής δεν μπορεί να             διαλέξει στόχο με βέβαιη απόρριψη.
         * @summary (Α-31) Υποψήφια προϊόντα για στόχο αντικατάστασης, για τον επιλογέα του popup. (Auth roles: Orders)
         * @param {ReturnReplacementSearchArgs} [ReturnReplacementSearchArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replacementSearch(ReturnReplacementSearchArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replacementSearch(ReturnReplacementSearchArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.replacementSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary (Α-31) Ο στόχος αντικατάστασης ενός τεμαχίου, όπως τον επιλέγει ο διαχειριστής. Επικυρώνεται έναντι του καταλόγου με τον <b>ίδιο</b> κανόνα που εφαρμόζει η υποβολή του πελάτη. (Auth roles: Orders)
         * @param {ReplacementSelectionArgs} [ReplacementSelectionArgs]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replacementSelection(ReplacementSelectionArgs, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replacementSelection(ReplacementSelectionArgs, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.replacementSelection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ίδιος κανόνας — και ίδιος κώδικας — με τους υποψηφίους που βλέπει ο πελάτης στο lookup, ώστε ο επιλογέας του διαχειριστή να μην προσφέρει παραλλαγή που η αποθήκευση θα απέρριπτε ως `returns_replacement_target_out_of_stock`.
         * @summary Οι παραλλαγές ενός προϊόντος που μπορούν να σταλούν ως αντικατάσταση: ορατές, με απόθεμα και με ενεργή βασική τιμή. (Auth roles: Orders)
         * @param {number} [productId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replacementVariants(productId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replacementVariants(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.replacementVariants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ReturnsApi - factory interface
 * @export
 */
const ReturnsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReturnsApiFp(configuration);
    return {
        /**
         * Το τροφοδοτεί ο διάλογος μαζικής αλλαγής κατάστασης και των δύο διαχειριστικών: η `returns/items` είναι όλα-ή-τίποτα, οπότε επιλέξιμος είναι μόνο στόχος που δέχεται <b>όλη</b> την επιλογή. `POST` για ανάγνωση με τα ids στο σώμα, όπως το `returns/lookup` της V2. Το σκεπτικό είναι στο `task-analysis/BW-7549`.
         * @summary Σε ποιες καταστάσεις μπορεί να πάει <b>όλη</b> η επιλογή τεμαχίων, και τι εμποδίζει τις υπόλοιπες. (Auth roles: Orders)
         * @param {ReturnBulkStatusOptionsArgs} [ReturnBulkStatusOptionsArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkStatusOptions(ReturnBulkStatusOptionsArgs, options) {
            return localVarFp.bulkStatusOptions(ReturnBulkStatusOptionsArgs, options).then((request) => request(axios, basePath));
        },
        /**
         * (Δεσμευτικό, Δ-06) Οι selectors απολυμαίνονται με allow-list σε `Filter`, `Sort`<b>και</b>`Group`, και το κριτήριο είναι η <b>απόρριψη</b>: άγνωστος selector οδηγεί σε σφάλμα αιτήματος και δεν προωθείται ποτέ αυτούσιος στο query.
         * @summary Η λίστα αιτημάτων, μία γραμμή ανά τεμάχιο. Ακολουθεί την υπάρχουσα σύμβαση των admin grids του εργαλείου: GET με `DataSourceLoadOptions` στο query string (απόφαση 2026-08-03). (Auth roles: Orders)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(loadOptions, options) {
            return localVarFp.getAll(loadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Το popup επεξεργασίας — το μόνο read surface που επιστρέφει τραπεζικά στοιχεία. (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Κατάσταση, επιθυμητή ενέργεια και παρατηρήσεις για <b>ένα</b> τεμάχιο. (Auth roles: Orders)
         * @param {ReturnItemUpdateArgs} [ReturnItemUpdateArgs]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        item(ReturnItemUpdateArgs, id, options) {
            return localVarFp.item(ReturnItemUpdateArgs, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Το ίδιο για επιλεγμένο σύνολο τεμαχίων — απαραίτητο επειδή ένα αίτημα «σκάει» σε πολλά τεμάχια. (Auth roles: Orders)
         * @param {ReturnItemsUpdateArgs} [ReturnItemsUpdateArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        items(ReturnItemsUpdateArgs, options) {
            return localVarFp.items(ReturnItemsUpdateArgs, options).then((request) => request(axios, basePath));
        },
        /**
         * Χωριστό, <b>authorised</b> endpoint και όχι το γενικό anonymous `binaryrepofiles/get`: οι φωτογραφίες επιστροφής είναι στοιχεία αιτήματος πελάτη (ενότητα 14). Ο τύπος περιεχομένου είναι ο <b>αναγνωρισμένος από magic bytes</b> που κρατά η γραμμή, όχι ο δηλωμένος από τον uploader.
         * @summary Το περιεχόμενο μιας φωτογραφίας πελάτη, για το popup του διαχειριστή. (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photo(id, options) {
            return localVarFp.photo(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary (Α-29) Καταγράφει επιστροφή χρημάτων που ο διαχειριστής έχει <b>ήδη εκτελέσει εκτός πλατφόρμας</b>. Καταγράφει γεγονός: δεν καλεί ποτέ πάροχο πληρωμών ή τράπεζα (Δ-10). (Auth roles: Orders)
         * @param {RefundExecutionArgs} [RefundExecutionArgs]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundExecution(RefundExecutionArgs, id, options) {
            return localVarFp.refundExecution(RefundExecutionArgs, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Επιτρέπεται μόνο όσο <b>κάθε</b> τεμάχιο είναι «Νέο αίτημα». (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary (Α-30) Καταγράφει αντικατάσταση που ο διαχειριστής έχει <b>ήδη στείλει</b>, ανά τεμάχιο (Δ-11). (Auth roles: Orders)
         * @param {ReplacementDispatchArgs} [ReplacementDispatchArgs]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replacementDispatch(ReplacementDispatchArgs, id, options) {
            return localVarFp.replacementDispatch(ReplacementDispatchArgs, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary (Α-30, Δ-11) Καταγράφει αποστολή <b>γραμμής του καλαθιού</b> αντικατάστασης — εκεί ζει ο στόχος όταν το αίτημα ήρθε από τον πελάτη (BW-7548). Η «Ολοκληρώθηκε» ανοίγει όταν έχουν καταγραφεί όλες οι γραμμές. (Auth roles: Orders)
         * @param {ReplacementLineDispatchArgs} [ReplacementLineDispatchArgs]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replacementLineDispatch(ReplacementLineDispatchArgs, id, options) {
            return localVarFp.replacementLineDispatch(ReplacementLineDispatchArgs, id, options).then((request) => request(axios, basePath));
        },
        /**
         *  Δικό του endpoint του module και όχι το `products/getsimplelookup` του καταλόγου, για δύο λόγους:             το lookup του καταλόγου είναι `[Authorize(Roles = \"Catalog\")]` ενώ αυτή η σελίδα είναι ρόλου             `Orders` — ένας διαχειριστής παραγγελιών έπαιρνε 403 και άδειο επιλογέα — και επιστρέφει             <b>ολόκληρο</b> τον κατάλογο χωρίς όρο ή σελιδοποίηση.  Η ίδια υπηρεσία με το storefront: ό,τι προσφέρεται εδώ το δέχεται και ο             BizWeb.NC.Returns.IReturnReplacementTargetResolver στην αποθήκευση, οπότε ο διαχειριστής δεν μπορεί να             διαλέξει στόχο με βέβαιη απόρριψη.
         * @summary (Α-31) Υποψήφια προϊόντα για στόχο αντικατάστασης, για τον επιλογέα του popup. (Auth roles: Orders)
         * @param {ReturnReplacementSearchArgs} [ReturnReplacementSearchArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replacementSearch(ReturnReplacementSearchArgs, options) {
            return localVarFp.replacementSearch(ReturnReplacementSearchArgs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary (Α-31) Ο στόχος αντικατάστασης ενός τεμαχίου, όπως τον επιλέγει ο διαχειριστής. Επικυρώνεται έναντι του καταλόγου με τον <b>ίδιο</b> κανόνα που εφαρμόζει η υποβολή του πελάτη. (Auth roles: Orders)
         * @param {ReplacementSelectionArgs} [ReplacementSelectionArgs]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replacementSelection(ReplacementSelectionArgs, id, options) {
            return localVarFp.replacementSelection(ReplacementSelectionArgs, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Ίδιος κανόνας — και ίδιος κώδικας — με τους υποψηφίους που βλέπει ο πελάτης στο lookup, ώστε ο επιλογέας του διαχειριστή να μην προσφέρει παραλλαγή που η αποθήκευση θα απέρριπτε ως `returns_replacement_target_out_of_stock`.
         * @summary Οι παραλλαγές ενός προϊόντος που μπορούν να σταλούν ως αντικατάσταση: ορατές, με απόθεμα και με ενεργή βασική τιμή. (Auth roles: Orders)
         * @param {number} [productId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replacementVariants(productId, options) {
            return localVarFp.replacementVariants(productId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReturnsApi - object-oriented interface
 * @export
 * @class ReturnsApi
 * @extends {BaseAPI}
 */
class ReturnsApi extends BaseAPI {
    /**
     * Το τροφοδοτεί ο διάλογος μαζικής αλλαγής κατάστασης και των δύο διαχειριστικών: η `returns/items` είναι όλα-ή-τίποτα, οπότε επιλέξιμος είναι μόνο στόχος που δέχεται <b>όλη</b> την επιλογή. `POST` για ανάγνωση με τα ids στο σώμα, όπως το `returns/lookup` της V2. Το σκεπτικό είναι στο `task-analysis/BW-7549`.
     * @summary Σε ποιες καταστάσεις μπορεί να πάει <b>όλη</b> η επιλογή τεμαχίων, και τι εμποδίζει τις υπόλοιπες. (Auth roles: Orders)
     * @param {ReturnBulkStatusOptionsArgs} [ReturnBulkStatusOptionsArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    bulkStatusOptions(ReturnBulkStatusOptionsArgs, options) {
        return ReturnsApiFp(this.configuration).bulkStatusOptions(ReturnBulkStatusOptionsArgs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * (Δεσμευτικό, Δ-06) Οι selectors απολυμαίνονται με allow-list σε `Filter`, `Sort`<b>και</b>`Group`, και το κριτήριο είναι η <b>απόρριψη</b>: άγνωστος selector οδηγεί σε σφάλμα αιτήματος και δεν προωθείται ποτέ αυτούσιος στο query.
     * @summary Η λίστα αιτημάτων, μία γραμμή ανά τεμάχιο. Ακολουθεί την υπάρχουσα σύμβαση των admin grids του εργαλείου: GET με `DataSourceLoadOptions` στο query string (απόφαση 2026-08-03). (Auth roles: Orders)
     * @param {DataSourceLoadOptions} [loadOptions]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    getAll(loadOptions, options) {
        return ReturnsApiFp(this.configuration).getAll(loadOptions, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Το popup επεξεργασίας — το μόνο read surface που επιστρέφει τραπεζικά στοιχεία. (Auth roles: Orders)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    getById(id, options) {
        return ReturnsApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Κατάσταση, επιθυμητή ενέργεια και παρατηρήσεις για <b>ένα</b> τεμάχιο. (Auth roles: Orders)
     * @param {ReturnItemUpdateArgs} [ReturnItemUpdateArgs]
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    item(ReturnItemUpdateArgs, id, options) {
        return ReturnsApiFp(this.configuration).item(ReturnItemUpdateArgs, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Το ίδιο για επιλεγμένο σύνολο τεμαχίων — απαραίτητο επειδή ένα αίτημα «σκάει» σε πολλά τεμάχια. (Auth roles: Orders)
     * @param {ReturnItemsUpdateArgs} [ReturnItemsUpdateArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    items(ReturnItemsUpdateArgs, options) {
        return ReturnsApiFp(this.configuration).items(ReturnItemsUpdateArgs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Χωριστό, <b>authorised</b> endpoint και όχι το γενικό anonymous `binaryrepofiles/get`: οι φωτογραφίες επιστροφής είναι στοιχεία αιτήματος πελάτη (ενότητα 14). Ο τύπος περιεχομένου είναι ο <b>αναγνωρισμένος από magic bytes</b> που κρατά η γραμμή, όχι ο δηλωμένος από τον uploader.
     * @summary Το περιεχόμενο μιας φωτογραφίας πελάτη, για το popup του διαχειριστή. (Auth roles: Orders)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    photo(id, options) {
        return ReturnsApiFp(this.configuration).photo(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary (Α-29) Καταγράφει επιστροφή χρημάτων που ο διαχειριστής έχει <b>ήδη εκτελέσει εκτός πλατφόρμας</b>. Καταγράφει γεγονός: δεν καλεί ποτέ πάροχο πληρωμών ή τράπεζα (Δ-10). (Auth roles: Orders)
     * @param {RefundExecutionArgs} [RefundExecutionArgs]
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    refundExecution(RefundExecutionArgs, id, options) {
        return ReturnsApiFp(this.configuration).refundExecution(RefundExecutionArgs, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Επιτρέπεται μόνο όσο <b>κάθε</b> τεμάχιο είναι «Νέο αίτημα». (Auth roles: Orders)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    remove(id, options) {
        return ReturnsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary (Α-30) Καταγράφει αντικατάσταση που ο διαχειριστής έχει <b>ήδη στείλει</b>, ανά τεμάχιο (Δ-11). (Auth roles: Orders)
     * @param {ReplacementDispatchArgs} [ReplacementDispatchArgs]
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    replacementDispatch(ReplacementDispatchArgs, id, options) {
        return ReturnsApiFp(this.configuration).replacementDispatch(ReplacementDispatchArgs, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary (Α-30, Δ-11) Καταγράφει αποστολή <b>γραμμής του καλαθιού</b> αντικατάστασης — εκεί ζει ο στόχος όταν το αίτημα ήρθε από τον πελάτη (BW-7548). Η «Ολοκληρώθηκε» ανοίγει όταν έχουν καταγραφεί όλες οι γραμμές. (Auth roles: Orders)
     * @param {ReplacementLineDispatchArgs} [ReplacementLineDispatchArgs]
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    replacementLineDispatch(ReplacementLineDispatchArgs, id, options) {
        return ReturnsApiFp(this.configuration).replacementLineDispatch(ReplacementLineDispatchArgs, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Δικό του endpoint του module και όχι το `products/getsimplelookup` του καταλόγου, για δύο λόγους:             το lookup του καταλόγου είναι `[Authorize(Roles = \"Catalog\")]` ενώ αυτή η σελίδα είναι ρόλου             `Orders` — ένας διαχειριστής παραγγελιών έπαιρνε 403 και άδειο επιλογέα — και επιστρέφει             <b>ολόκληρο</b> τον κατάλογο χωρίς όρο ή σελιδοποίηση.  Η ίδια υπηρεσία με το storefront: ό,τι προσφέρεται εδώ το δέχεται και ο             BizWeb.NC.Returns.IReturnReplacementTargetResolver στην αποθήκευση, οπότε ο διαχειριστής δεν μπορεί να             διαλέξει στόχο με βέβαιη απόρριψη.
     * @summary (Α-31) Υποψήφια προϊόντα για στόχο αντικατάστασης, για τον επιλογέα του popup. (Auth roles: Orders)
     * @param {ReturnReplacementSearchArgs} [ReturnReplacementSearchArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    replacementSearch(ReturnReplacementSearchArgs, options) {
        return ReturnsApiFp(this.configuration).replacementSearch(ReturnReplacementSearchArgs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary (Α-31) Ο στόχος αντικατάστασης ενός τεμαχίου, όπως τον επιλέγει ο διαχειριστής. Επικυρώνεται έναντι του καταλόγου με τον <b>ίδιο</b> κανόνα που εφαρμόζει η υποβολή του πελάτη. (Auth roles: Orders)
     * @param {ReplacementSelectionArgs} [ReplacementSelectionArgs]
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    replacementSelection(ReplacementSelectionArgs, id, options) {
        return ReturnsApiFp(this.configuration).replacementSelection(ReplacementSelectionArgs, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Ίδιος κανόνας — και ίδιος κώδικας — με τους υποψηφίους που βλέπει ο πελάτης στο lookup, ώστε ο επιλογέας του διαχειριστή να μην προσφέρει παραλλαγή που η αποθήκευση θα απέρριπτε ως `returns_replacement_target_out_of_stock`.
     * @summary Οι παραλλαγές ενός προϊόντος που μπορούν να σταλούν ως αντικατάσταση: ορατές, με απόθεμα και με ενεργή βασική τιμή. (Auth roles: Orders)
     * @param {number} [productId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    replacementVariants(productId, options) {
        return ReturnsApiFp(this.configuration).replacementVariants(productId, options).then((request) => request(this.axios, this.basePath));
    }
}

export { ReturnsApi, ReturnsApiAxiosParamCreator, ReturnsApiFactory, ReturnsApiFp };
//# sourceMappingURL=returns-api.js.map
